export enum NotificationPriority {
  BASSA = 'BASSA',
  NORMALE = 'NORMALE',
  ALTA = 'ALTA',
  URGENTE = 'URGENTE',
}

export enum NotificationType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  NOTIFICA = 'NOTIFICA',
}
